const langPackLocalVersion = 11;export default langPackLocalVersion;
